import React from 'react';
import { Switch } from 'antd';
import { DataMatchGroup } from '../../../types/proccesingJobs';
import Styled from '../listItemHead.styled';
import MatchStatusIcon from './MatchStatusIcon';

const { JobTitle, JobValue, SubTitleWrapper, HeadingWrapper, Wrapper } = Styled;

interface OwnProps {
  matchGroup: DataMatchGroup;
  onToggleMatches: (isSet: boolean, matchGroup: DataMatchGroup) => void;
}

const GroupListItemMatch = ({ matchGroup, onToggleMatches }: OwnProps) => (
  <Wrapper>
    <HeadingWrapper>
      <SubTitleWrapper>
        <JobTitle>Data Type:</JobTitle>
        <JobValue>{matchGroup.dataType}</JobValue>
      </SubTitleWrapper>
      <SubTitleWrapper>
        <JobTitle>Value:</JobTitle>
        <JobValue>{matchGroup.value}</JobValue>
      </SubTitleWrapper>
      <SubTitleWrapper>
        <JobTitle>Match:</JobTitle>
        <MatchStatusIcon matchType={matchGroup.matchType} />
        <Switch defaultChecked={false} onChange={(value) => onToggleMatches(value, matchGroup)} />
      </SubTitleWrapper>
    </HeadingWrapper>
  </Wrapper>
);

export default GroupListItemMatch;
